import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Spin, Result } from 'antd';
import { getLicense } from '../services/api';

// Import all version components
import LicenseViewV1 from '../pages/version/v1/LicensePublic/LicenseView';
import LicenseViewV2 from '../pages/version/v2/LicensePubilc/LicensePublicView';

// Version configuration
const VERSION_COMPONENTS = {
  1: LicenseViewV1,
  2: LicenseViewV2,
  // Add new versions here
  // 3: LicenseViewV3,
  // 4: LicenseViewV4,
};

const DEFAULT_VERSION = 2; // Set your default version

const VersionRouter = () => {
  const { id: pathId } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState(null);
  const [error, setError] = useState(null);
  const [licenseData, setLicenseData] = useState(null);

  useEffect(() => {
    const fetchLicenseVersion = async () => {
      try {
        // Get ID from either path or query params
        const params = new URLSearchParams(location.search);
        const queryId = params.get('id');
        const id = pathId || queryId;

        if (!id) {
          throw new Error('未提供营业执照ID');
        }

        const response = await getLicense(id);
        const data = response.data;
        setLicenseData(data);

        // 直接使用后端返回的version字段
        const licenseVersion = data.version || DEFAULT_VERSION;
        console.log("营业执照版本:", licenseVersion);
        
        // 验证版本组件是否存在
        if (!VERSION_COMPONENTS[licenseVersion]) {
          console.warn(`未找到版本 ${licenseVersion} 的组件，使用默认版本 ${DEFAULT_VERSION}`);
          setVersion(DEFAULT_VERSION);
        } else {
          setVersion(licenseVersion);
        }
      } catch (error) {
        console.error('获取营业执照信息失败:', error);
        setError(error.message || '获取营业执照信息失败');
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseVersion();
  }, [pathId, location.search]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="正在加载营业执照信息..." />
      </div>
    );
  }

  if (error) {
    return (
      <Result
        status="error"
        title="无法加载营业执照"
        subTitle={error}
        extra={[
          <p key="contact" style={{ color: '#666', marginTop: '20px' }}>
            如果问题持续存在，请联系管理员。
          </p>
        ]}
      />
    );
  }

  if (!licenseData) {
    return (
      <Result
        status="warning"
        title="未找到营业执照信息"
        subTitle="请检查URL参数是否正确，或联系管理员获取有效链接。"
      />
    );
  }

  // Get the component for the current version
  const LicenseComponent = VERSION_COMPONENTS[version] || VERSION_COMPONENTS[DEFAULT_VERSION];
  
  return <LicenseComponent license={licenseData} version={version} />;
};

export default VersionRouter; 